import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import Label from 'ui-library/bs/Label';
import {ButtonStyle} from 'ui-library/buttons/Button';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Modal, {ModalButton} from 'ui-library/modals/Modal';
import {
  ExperimentalCondition,
  ExperimentalConditionValue,
  STAGE_CONFIGURATION_FULL_SHAPE,
  STAGE_FLOW_NODE_FULL_SHAPE,
  StageConfiguration,
  StageFlowNode,
} from 'workflows/WorkflowConstants';

const NO_VALUE = '_NO_VALUE';

interface SetExperimentalConditionsModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (experimentalConditionValueIds: Array<string>) => void;
  stageFlowNode: StageFlowNode;
  stageConfiguration: StageConfiguration;
}

interface State {
  experimentalConditionValues: Array<ExperimentalConditionValue>;
}

class SetExperimentalConditionsModal extends React.Component<SetExperimentalConditionsModalProps, State> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    onRequestClose: PropTypes.func.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,
    stageFlowNode: STAGE_FLOW_NODE_FULL_SHAPE.isRequired,
    stageConfiguration: STAGE_CONFIGURATION_FULL_SHAPE.isRequired,
  };

  state: State = {
    experimentalConditionValues: this.props.stageFlowNode.experimentalConditionValues,
  };

  _getButtons(): Array<ModalButton> {
    return [
      {
        text: 'Save',
        style: ButtonStyle.PRIMARY,
        onClick: this._handleSubmit,
        key: 'save',
      },
    ];
  }

  _handleSubmit = (): void => {
    this.props.onRequestSubmit(this.state.experimentalConditionValues.map((ecVal) => ecVal.id!));
  };

  _ecValueSelected(experimentalCondition: ExperimentalCondition, textValue: string): void {
    // eslint-disable-next-line no-restricted-syntax
    let experimentalConditionValues = _.reject(
      this.state.experimentalConditionValues,
      (val) => val.name === experimentalCondition.name
    );
    if (textValue !== NO_VALUE) {
      experimentalConditionValues = [
        ...experimentalConditionValues,
        _.findWhere(experimentalCondition.values, {textValue})!,
      ];
    }
    this.setState({
      experimentalConditionValues,
    });
  }

  render(): JSX.Element {
    return (
      <Modal
        title="Set experimental conditions"
        onRequestClose={this.props.onRequestClose}
        buttons={this._getButtons()}
      >
        {this.props.stageConfiguration.experimentalConditions.map((experimentalCondition) => {
          if (experimentalCondition.values.length === 0) {
            return null;
          }
          return (
            <div key={experimentalCondition.name} className="workflowConfigureScreen-groupBox">
              <div className="u-tiny-spacing-bottom">
                <FieldLabel label={<span>{experimentalCondition.name}</span>} />
              </div>
              {experimentalCondition.values.map((ecValue, index) => (
                <div key={`${experimentalCondition.name}:value${index}`} className="radio">
                  <Label>
                    <input
                      type="radio"
                      checked={
                        _.findWhere(this.state.experimentalConditionValues, {
                          name: ecValue.name,
                          textValue: ecValue.textValue,
                        }) != null
                      }
                      value={ecValue.textValue}
                      onChange={({target: {value}}) => {
                        this._ecValueSelected(experimentalCondition, value);
                      }}
                    />
                    {ecValue.textValue}
                  </Label>
                </div>
              ))}
              <div key={`${experimentalCondition.name}:None`} className="radio">
                <Label>
                  <input
                    type="radio"
                    checked={
                      _.findWhere(this.state.experimentalConditionValues, {
                        name: experimentalCondition.name,
                      }) == null
                    }
                    value={NO_VALUE}
                    onChange={({target: {value}}) => {
                      this._ecValueSelected(experimentalCondition, value);
                    }}
                  />
                  None
                </Label>
              </div>
            </div>
          );
        })}
      </Modal>
    );
  }
}

export default SetExperimentalConditionsModal;
